module.exports = __webpack_public_path__ + "assets/img/avi.1c2cd499.png";